import React, { useState } from "react";
import { getData, postData, postFormData } from '../middleware/apiMiddleware';
import s from './VocabBatchProcess.module.css';
import { useNavigate } from "react-router-dom";

export default function VocabBatchProcess() {
	const navigate = useNavigate();
    const [batchInput, setBatchInput] = useState('');

    const handleInputChange = (e) => {
        setBatchInput(e.target.value);
    };

    const handleProcess = async () => {
        const wordList = batchInput
            .split('\n')
            .map(word => word.trim())
            .filter(word => word !== '');

        
        await postData("vocabApi/processVocabAdv", {
            vocabs: wordList,
        }, navigate);
        alert(`Total valid words: ${wordList.length}\nWord list:\n${wordList.join('\n')}`);
    };

    const isInputEmpty = batchInput.trim() === '';

    return (
        <div className={s.batchContainer}>
            <h2 className={s.batchTitle}>Batch Vocabulary Process</h2>

            <textarea
                className={s.vocabTextarea}
                value={batchInput}
                onChange={handleInputChange}
                placeholder="Enter vocabulary list here, one word per line only"
            />

            <button
                className={s.processBtn}
                onClick={handleProcess}
                disabled={isInputEmpty}
            >
                Process
            </button>
        </div>
    );
}